import { useContext } from 'react';
import { NavigationRestrictionContext } from '../contexts/navigationRestrictionContext';

export const useNavigationRestrictionContext = () => useContext(NavigationRestrictionContext);
